const SCRIPT_URL = (
  process.env.REACT_APP_GOOGLE_SCRIPT_URL || ""
).trim();
const ADMIN_TOKEN_KEY = "maskanh_admin_token";

const assertConfigured = () => {
  if (!SCRIPT_URL || SCRIPT_URL.includes("PASTE_YOUR")) {
    throw new Error(
      "Google Sheets integration is not configured yet. Please add REACT_APP_GOOGLE_SCRIPT_URL to your .env file."
    );
  }
};

const buildAdminUrl = (params = {}) => {
  assertConfigured();
  const url = new URL(SCRIPT_URL);
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
};

const getAdminToken = () => {
  if (typeof window === "undefined") return "";
  return (window.localStorage.getItem(ADMIN_TOKEN_KEY) || "").trim();
};

export const setAdminToken = (token) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token.trim());
};

export const clearAdminToken = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const submitForm = async (data) => {
  assertConfigured();

  const response = await fetch(SCRIPT_URL, {
    method: "POST",
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });

  return response;
};

export const getAdminDashboardData = async () => {
  const response = await fetch(
    buildAdminUrl({ mode: "admin-dashboard", adminToken: getAdminToken() }),
    {
    method: "GET",
    }
  );

  if (!response.ok) {
    throw new Error("Failed to load admin dashboard data.");
  }

  const json = await response.json();
  if (json && json.success === false) {
    throw new Error(json.error || "Admin dashboard request failed.");
  }
  return json;
};

export const updateJobStatus = async ({ jobId, status }) => {
  const response = await fetch(
    buildAdminUrl({
      mode: "update-status",
      adminToken: getAdminToken(),
      jobId,
      status,
    }),
    { method: "GET" }
  );

  if (!response.ok) {
    throw new Error("Failed to update job status.");
  }

  const json = await response.json();
  if (json && json.success === false) {
    throw new Error(json.error || "Failed to update job status.");
  }
  return json;
};

export const overrideJobAssignment = async ({ jobId, technicianId }) => {
  const response = await fetch(
    buildAdminUrl({
      mode: "override-assignment",
      adminToken: getAdminToken(),
      jobId,
      technicianId,
    }),
    { method: "GET" }
  );

  if (!response.ok) {
    throw new Error("Failed to override assignment.");
  }

  const json = await response.json();
  if (json && json.success === false) {
    throw new Error(json.error || "Failed to override assignment.");
  }
  return json;
};
